import React from "react";
import classNames from "classnames";

export default function Icon(props) {
  const { className, name, ...rest } = props;

  return (
    <img
      className={classNames("icon", `is-${name}`, className)}
      src={`/static/svgs/${name}.svg`}
      {...rest}
    />
  );
}
